<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <FertiliserAdditives />
    </div>
</template>

<script>
import currentUserQuery from '@views/FertiliserAdditives/Browse/queryCurrentUser.graphql';

import FertiliserAdditives from '../FertiliserAdditives/Browse.vue';

export default {
  name: 'FertiliserAdditivesContainer',
  components: {
    FertiliserAdditives,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['developer', 'admin', 'association'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
